export const PHONE_EXCESSIVE_CHARS_REG_EXP = /[\s+-/()]/g

// Похоже на почту: имя@домен.зона. Любые зоны (.рф, .su, .pro…): адрес до конца проверяет сервер.
export const EMAIL_REG_EXP = /^[^\s@]+@[^\s@]+\.[^\s@.]{2,}$/

export const PHONE_REG_EXP = /^\+7 \d{3} \d{3}-\d{2}-\d{2}$/

export const THOUSANDS_REG_EXP = /\B(?=(\d{3})+(?!\d))/g

export const TIME_INTERVAL_REG_EXP
  = /^((?:[01]\d:[0-5]\d|2[0-3]:[0-5]\d)\s?-\s?(?:[01]\d:[0-5]\d|2[0-3]:[0-5]\d))$/

export const TIME_REG_EXP = /^([01]\d|2[0-3]):[0-5]\d$/

export const INN_REG_EXP = /^\d{10}$|^\d{12}$/

export const URL_REG_EXP = /^(https?:\/\/)?([\w.-]+\.[a-z]{2,6})(\/[\w.-]*)*(\?[^#]*)?(#.*)?$/i
